<!--
/**
* @name: List.vue
* @description: 交易管理-仓库设置列表页面
* @author: 杨波
* @create: 2020/08/17 14:06:58
* @update: 2020/08/17 14:06:58
*/
-->

<template>
  <y-view>
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item>
        <k-input placeholder="请输入仓库编码/名称" clearable v-model="para.keywords"></k-input>
      </y-query-item>
      <y-query-item>
        <k-button type="primary" @click="onSearch">查询</k-button>
      </y-query-item>
      <y-query-item>
        <k-button @click="onReset">重置</k-button>
      </y-query-item>
      <y-query-item slot="right">
        <y-button icon="k-icon-add" @click="onAddWarehouse">新建</y-button>
      </y-query-item>
    </y-query>
    <k-table :data="wareList" :height="$root.tableHeightX" :rightFixedNumber="1" :columns="initColumns()"></k-table>
    <k-pagination v-if="wareList && wareList.length > 0" :total="total" :current-page.sync="para.pageCurrent" :page-size.sync="para.pageSize" @page-change="onChangePageIndex" />
  </y-view>
</template>

<script>
import { NESTLE_TRADE_BACK_SERVER_WAREHOUSE_BUY_RULE_PAGE } from "@/assets/modules/apiList";
const initPara = () => ({
  keywords: "",
  pageCurrent: 1,
  pageSize: 15,
});
export default {
  data() {
    return {
      wareList: [],
      para: initPara(),
      total: 0,
    };
  },
  methods: {
    initColumns() {
      return [
        {
          name: "仓库编码",
          field: "code",
          style: {
            width: 180,
            textAlign: "center",
          },
          customRender: (row) => {
            const valueStr = <span>{row.warehouse.code}</span>;
            return <div>{valueStr}</div>;
          },
        },
        {
          name: "仓库名称",
          field: "name",
          style: {
            width: 180,
            textAlign: "center",
          },
          customRender: (row) => {
            const valueStr = <span>{row.warehouse.name}</span>;
            return <div>{valueStr}</div>;
          },
        },
        {
          name: "贸易模式",
          field: "tradeModeName",
          style: {
            width: 100,
            textAlign: "center",
          },
          customRender: (row) => {
            const valueStr = <span>{row.warehouse.tradeModeName}</span>;
            return <div>{valueStr}</div>;
          },
        },
        {
          name: "库位类型",
          field: "wareSeatTypeName",
          style: {
            width: 100,
            textAlign: "center",
          },
          customRender: (row) => {
            const valueStr = <span>{row.warehouse.wareSeatTypeName}</span>;
            return <div>{valueStr}</div>;
          },
        },
        {
          name: "质量状态",
          field: "qualityTypeName",
          style: {
            width: 120,
            textAlign: "center",
          },
          customRender: (row) => {
            const valueStr = <span>{row.warehouse.qualityTypeName}</span>;
            return <div>{valueStr}</div>;
          },
        },
        {
          name: "操作",
          field: "action",
          style: {
            textAlign: "center",
            width: 50,
          },
          customRender: (row) => {
            const editButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onEditWarehouse(row);
                }}
              >
                编辑
              </a>
            );
            return <div>{editButton}</div>;
          },
        },
      ];
    },
    onAddWarehouse() {
      this.$controller.open({
        name: "warehouseAdd",
        query: {
          refresh: new Date() - 0,
        },
      });
    },
    onEditWarehouse(row) {
      this.$controller.open({
        name: "warehouseAdd",
        query: {
          refresh: new Date() - 0,
          id: row.id,
          edit: 1,
        },
        title: "编辑仓库",
      });
    },
    onSearch() {
      this.para.pageCurrent = 1;
      this.getWareList();
    },
    onReset() {
      this.para = initPara();
      this.getWareList();
    },
    onChangePageIndex(p) {
      this.para.pageCurrent = p;
      this.getWareList();
    },
    getWareList() {
      let { para } = this;
      this.$fetch({
        api: NESTLE_TRADE_BACK_SERVER_WAREHOUSE_BUY_RULE_PAGE,
        para,
      }).then((res) => {
        this.wareList = res.pageList;
        this.total = res.total;
      });
    },
  },
  created() {
    this.getWareList();
  },
  beforeRouteUpdate(to, from, next) {
    this.getWareList();
    next();
  },
};
</script>

<style lang="postcss" module="css"></style>
